/** Formation en ligne Méthode Ozentya (ozentyaformation.com) : contenu repris du site de la formation, prix de lancement. */
export const FORMATION_PATH = "/formation";
/** 49 € jusqu'au 8 novembre 2026 à 08 h 18 (Paris), puis 245 €. Après cette date, aucun prix n'est affiché sur ozentya.net. */
export const FORMATION_PRICE = { now: 49, after: 245, until: Date.parse("2026-11-08T07:18:12Z") };

export function formationPrice(now = Date.now()) {
  if (now >= FORMATION_PRICE.until) return null;
  const until = new Date(FORMATION_PRICE.until).toLocaleString("fr-FR", { day: "numeric", month: "long", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Paris" });
  return { now: FORMATION_PRICE.now, after: FORMATION_PRICE.after, until, left: FORMATION_PRICE.until - now };
}

export const FORMATION_POINTS = [
  "Comprendre le cheveu afro : texture, porosité, élasticité, cuir chevelu",
  "La méthode 5D pour ne plus conseiller au hasard",
  "Construire des routines adaptées et un suivi",
  "47 leçons en 7 modules, 100 % en ligne, à votre rythme, accès à vie",
];

export const FORMATION_FOR = [
  ["Pour vos propres cheveux", "Comprenez enfin vos cheveux et adoptez une routine vraiment adaptée."],
  ["Coiffeuses et coiffeurs afro", "Ajoutez une vraie dimension conseil à votre savoir-faire technique."],
  ["Esthéticiennes", "Élargissez vos prestations au soin du cheveu et du cuir chevelu."],
  ["Vente de produits capillaires", "Recommandez avec méthode plutôt que de vendre au hasard."],
  ["Création d'activité, reconversion", "Partez sur des bases solides, à votre rythme."],
];

export const FORMATION_5D = [
  ["Décrire", "Observer et comprendre la situation."],
  ["Déterminer", "Identifier les besoins apparents."],
  ["Détecter", "Repérer les habitudes pouvant fragiliser le cheveu."],
  ["Définir", "Déterminer un objectif cosmétique réaliste."],
  ["Développer", "Construire une routine et un suivi adaptés."],
];

export const FORMATION_INCLUDED = [
  "Formation complète en diaporamas commentés (47 leçons, 7 modules)",
  "Fiche diagnostic capillaire Ozentya et questionnaire cliente",
  "10 exemples de routines et protocoles",
  "Fiches de suivi",
  "20 messages WhatsApp prêts à utiliser et 30 idées de contenus Instagram",
  "Modèle de grille tarifaire et cas pratiques",
  "Accès à vie, mises à jour, certificat",
];

export const FORMATION_FAQ = [
  { q: "Puis-je suivre la formation pour mes propres cheveux ?", a: "Oui. La formation s'adresse aussi aux femmes et aux hommes qui veulent comprendre leurs cheveux et adopter une routine adaptée, pas seulement aux professionnels." },
  { q: "La formation est-elle entièrement en ligne ?", a: "Oui : 47 leçons en diaporamas commentés, à suivre à votre rythme sur ordinateur, tablette ou téléphone, avec un accès à vie à votre espace élève." },
  { q: "Faut-il un diplôme ?", a: "Non. La Méthode Ozentya enseigne une approche cosmétique, pratique et professionnelle du conseil capillaire ; elle ne remplace pas un avis médical." },
  { q: "Qui a créé la formation ?", a: "Pascal Chaubo, fondateur d'Ozentya, qui évolue depuis 15 ans dans la cosmétique afro et le soin capillaire." },
];
